<!--
商品详情页图文内容

使用说明：

<ProductDetailBody
 :product="{Product}"
 />

Product={
  content: '商品详情,HTML'
}
-->

<template>
  <div class="wrap">
    <div class="product-detail" v-html="product.content"></div>
    <div class="product-hint">商品编号：{{skuId}}</div>
  </div>
</template>

<script>
export default {
  props: ["product"],
  data(){
    return {
      skuId: this.$route.query.skuId,
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.wrap {
  margin-top: 1.06vw;
}

.product-detail {
  width: 100vw;

  * {
    display: block;
  }
}

.product-hint{
  text-align: center;
  color: #aaa;
  font-size: 3vw;
  line-height: 4em;
}
</style>

<style lang="less">
.product-detail {
  img {
    display: block;
    max-width: 100vw;
    border: none;
    margin: 0;
  }

  div{
  }
}
</style>





// WEBPACK FOOTER //
// src/components/products/ProductDetailBody.vue